import { render, staticRenderFns } from "./PersonaForm.vue?vue&type=template&id=29ed0304&scoped=true"
import script from "./PersonaForm.vue?vue&type=script&lang=js"
export * from "./PersonaForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ed0304",
  null
  
)

export default component.exports